/**
 * Front-end feature flags. Keep these as plain `const` so dead-code
 * elimination removes the disabled branches at build time.
 *
 * PAYMENTS_ENABLED — gates every surface that mentions paid plans,
 * subscribe buttons, or the PayPal widget. While this is false:
 *   - Sidebar footer "Upgrade Plan" button is hidden
 *   - Header gear-icon "Edit plan" dropdown item is hidden
 *   - In-app PricingPage (/settings/edit-plan) renders an info-only
 *     view without subscribe CTAs
 *   - /settings/subscribe redirects home (PayPal cannot render)
 *   - Onboarding "Upgrade your plan" nudges are hidden
 * Everything customer-facing about more credits goes through the
 * "Request beta upgrade" modal instead, which queues an admin review
 * with no payment.
 */
export const PAYMENTS_ENABLED = false;
